/**
 * Created by developer1 on 30.03.2017.
 */
$(function () {

    $(document).on('click','[data-collapse]', function () {
        var $this = $(this),
            $collapses = $('.service-select__item__collapse-container');
        console.log($this.data('collapse'));
        $collapses.stop().removeClass('active').slideUp();
        var $el = $this.data('collapse');
        $($el).stop().addClass('active').slideDown();
    });

    $(document).on('change','[name=club-filter]', function () {
        var $this = $(this);
        $(document).trigger('club:filter:'+ $this.val());
        console.log('club:filter:'+ $this.val());
        $('.service-select__item__collapse-container').stop().removeClass('active').removeAttr("style");//.hide();
    });

    $(document).on('club:filter:plaza', function () {
        $('.service-select__item__container').attr('data-filter', 'plaza');
    }).on('club:filter:vzlet', function () {
        $('.service-select__item__container').attr('data-filter', 'vzlet');
    })

});
